import DataObjectField from '@/utilities/classes/data-object-field';

const buildLandlordResubmissionDataObject = (vData)  => {

  const fields = [];

  if(vData.ApplicantPropertyOwner != null){
    fields.push(new DataObjectField(vData.ApplicantPropertyOwner, 71));
  }
  if(vData.PropertyManagementRepresentative.ContactInformation.CompanyName != null){
    fields.push(new DataObjectField(vData.PropertyManagementRepresentative.ContactInformation.CompanyName, 163));
  }
  if(vData.PropertyManagementRepresentative.ContactInformation.FirstName != null){
    fields.push(new DataObjectField(vData.PropertyManagementRepresentative.ContactInformation.FirstName, 31));
  }
  if(vData.PropertyManagementRepresentative.ContactInformation.LastName != null){
    fields.push(new DataObjectField(vData.PropertyManagementRepresentative.ContactInformation.LastName, 32));
  }
  if(vData.PropertyManagementRepresentative.ContactInformation.CellPhone != null){
    fields.push(new DataObjectField(vData.PropertyManagementRepresentative.ContactInformation.CellPhone, 34));
  }
  if(vData.PropertyManagementRepresentative.ContactInformation.EmailAddress != null){
    fields.push(new DataObjectField(vData.PropertyManagementRepresentative.ContactInformation.EmailAddress, 33));
  }
  if(vData.Landlord.ComplaintFiled != null){
    fields.push(new DataObjectField(vData.Landlord.ComplaintFiled, 110));
  }
  if(vData.Landlord.LTFilingNumber != null){
    fields.push(new DataObjectField(vData.Landlord.LTFilingNumber, 767));
  }
  if(vData.Landlord.TFAPrevious != null){
    fields.push(new DataObjectField(vData.Landlord.TFAPrevious, 74));
  }
  if(vData.Landlord.RentOrFeesOwed != null){
    fields.push(new DataObjectField(vData.Landlord.RentOrFeesOwed, 64));
  }
  if(vData.Landlord.AmountOwedInArrears != null){
    fields.push(new DataObjectField(vData.Landlord.AmountOwedInArrears, 65));
  }
  if(vData.Landlord.TFAOptIn != null){
    fields.push(new DataObjectField(vData.Landlord.TFAOptIn, 73));
  }

  const dataObject = {
    qdbapi: {
      rid: Number(vData.appid),
      udata : "EVICTION_DIVERSION_TFA_APPLICATION",
      clist: "32",
      field: fields,
    },
  };
  return dataObject;
};

export default buildLandlordResubmissionDataObject;